import { Grid2, Tooltip, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { handleCopy } from "../support/utils";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
//asda

const ClickToCopy = ({ content, label, variant, width, link, tooltip }) => {
  const [iconToShow, setIconToShow] = useState("copy");
  const theme = useTheme();
  return (
    <Tooltip title={tooltip} enterDelay={tooltip ? 700 : 10000}>
      <Grid2 container sx={{ width: width }} alignItems="center">
        <Grid2 size={"grow"}>
          <Typography
            variant={variant}
            onMouseLeave={() => setIconToShow("copy")}
            onTouchEnd={() => setIconToShow("copy")}
            onClick={() => {
              handleCopy(content);
              setIconToShow("copied");
            }}
            onHover={{}}
            sx={{
              cursor: "pointer",
              "&:hover": {
                color: "#999999",
              },
            }}
          >
            {label}
          </Typography>
        </Grid2>
        <Grid2 sx={{ display: "grid" }}>
          {iconToShow === "copied" ? (
            <CheckIcon sx={{ height: 15 }} />
          ) : (
            <ContentCopyIcon sx={{ height: 15, color: "#999999" }} />
          )}
        </Grid2>
        <Grid2 sx={{ margin: 0, display: "grid" }}>
          <OpenInNewIcon
            onClick={() => window.open(link, "_blank")}
            sx={{
              margin: 0,
              width: 15,
              height: 15,
              color: "#999999",
              cursor: "pointer",
              "&:hover": {
                color: theme.palette.text.primary,
              },
            }}
          />
        </Grid2>
      </Grid2>
    </Tooltip>
  );
};

export default ClickToCopy;
